import React, { useState, useEffect } from 'react';
import axios from 'axios';

let ws;
const useQueue = (loginId, reservationTimePerUser = 1) => {
  const [socket, setSocket] = useState(null);
  const [queue, setQueue] = useState([]);
  const [position, setPosition] = useState(-1);
  const [reservationCount, setReservationCount] = useState(0);
  const [move, setMove] = useState(false);
  const [estimatedWaitTime, setEstimatedWaitTime] = useState(0);
  // const [queueActive, setQueueActive] = useState('0');
  // const { queueActive } = queueJson;
  // console.log(queueJson);
  // let queueActive = '1';

  const getAcitve = async () => {
    // const result = await axios.get('https://www.aniplustv.com/queue.json');
    const result = await axios.get(
      'https://api.aniplustv.com:3100/queueActive'
    );
    console.log(result.data[0].queueActive);
    // console.log(Base64.encode('admin'));
    // if (loginId === 'YWRtaW4=') {
    //   //관리자일 경우.
    //   setMove(true);
    // } else {
    if (result.data[0].queueActive === 'Y') {
      // const ws = new WebSocket('wss://queue.aniplustv.com');
      ws = new WebSocket('wss://queue.aniplustv.com');
      // const ws = new WebSocket('ws://son.aniplustv.com:8080');
      setSocket(ws);

      ws.onopen = async () => {
        // 접속시 자동으로 대기열에 입력.
        if (loginId === '' || loginId === null || loginId === undefined) {
          // ws.send(
          //   JSON.stringify({ type: 'joinQueue', data: { userId: loginId } })
          // );
        } else {
          ws.send(
            JSON.stringify({ type: 'joinQueue', data: { userId: loginId } })
          );
        }
      };

      ws.onmessage = (message) => {
        // console.log(message);
        const { type, data, reservationCount } = JSON.parse(message.data);
        // console.log(type, data, reservationCount);

        switch (type) {
          case 'queueData':
            setQueue(data);
            updatePosition(data);
            setReservationCount(reservationCount);
            break;
          case 'queueStatus':
            // console.log(data);
            break;
          case 'reservationCount':
            setReservationCount(data);
            break;
          // case 'moveToReservation':
          //   console.log(loginId, data);
          //   if (loginId === data) {
          //     setMove(true);
          //   }
          //   break;
          case 'enterPage':
            console.log(loginId, data);
            if (loginId === data) {
              setMove(true);
            }
            break;
          case 'error':
            // console.error(data);
            break;
          default:
            break;
        }
      };

      ws.onclose = () => {
        // console.log('onclose', loginId);
        // socket.send(
        //   JSON.stringify({ type: 'leaveQueue', data: { userId: loginId } })
        // );
        console.log('Disconnected from WebSocket server');
      };
    } else {
      setMove(true);
    }
    // }

    // setQueueActive(result.data.queueActive);
  };

  const sleep = (ms) => {
    return new Promise((r) => setTimeout(r, ms));
  };

  const allLeaveQueue = async () => {
    for (let i = 0; i <= 10; i++) {
      socket.send(
        JSON.stringify({
          type: 'leaveQueue',
          data: { userId: loginId + i.toString() },
        })
      );

      await sleep(1000);
    }
  };

  useEffect(() => {
    getAcitve();
    // return () => {
    //   console.log('aaaaaaaaaaaaaaaaaaaaaa');
    //   leaveQueue();
    // };
  }, [loginId]);

  const joinQueue = () => {
    // console.log('joinQueue...' + loginId);
    if (loginId && socket) {
      socket.send(
        JSON.stringify({ type: 'joinQueue', data: { userId: loginId } })
      );
    }
  };
  const leaveQueue = () => {
    console.log('leaveQueue...' + loginId, loginId, socket);
    // const ws = new WebSocket('ws://son.aniplustv.com:8080');
    if (loginId && socket) {
      socket.send(
        JSON.stringify({ type: 'leaveQueue', data: { userId: loginId } })
      );
      // socket.close();
    } else if (ws) {
      ws.send(
        JSON.stringify({ type: 'leaveQueue', data: { userId: loginId } })
      );
    }
  };
  const leaveReservation = () => {
    if (loginId && socket) {
      socket.send(
        JSON.stringify({ type: 'leaveReservation', data: { userId: loginId } })
      );
      // socket.close();
    } else if (ws) {
      ws.send(
        JSON.stringify({ type: 'leaveReservation', data: { userId: loginId } })
      );
    }
  };
  const updatePosition = (queue) => {
    const index = queue.indexOf(loginId);
    setPosition(index);
    calculateEstimatedWaitTime(index);
  };
  const calculateEstimatedWaitTime = (position) => {
    // console.log('position ->' + position);
    if (position !== -1) {
      const waitTime = (position + 1) * reservationTimePerUser;
      setEstimatedWaitTime(waitTime);
    } else {
      setEstimatedWaitTime(0);
    }
  };

  return {
    queue,
    position,
    reservationCount,
    estimatedWaitTime,
    move,
    joinQueue,
    leaveQueue,
    allLeaveQueue,
    setMove,
    leaveReservation,
  };
};

export default useQueue;
